import { useState } from 'react';

const faqs = [
  {
    q: '奇优影院需要注册才能观看吗？',
    a: '不需要注册，奇优影院所有影视内容均可免费在线观看，无需任何注册或登录。您可以直接访问网站，选择喜欢的影片开始观看。',
  },
  {
    q: '视频播放时缓冲卡顿怎么办？',
    a: '奇优影院采用先进的CDN加速技术和智能码率调节系统，可根据您的网络状况自动调整画质。如果遇到卡顿，建议检查网络连接或尝试切换播放线路。',
  },
  {
    q: '新片上线需要多久才能在奇优影院看到？',
    a: '我们拥有专业的内容更新团队，热门新片上映后通常24小时内即可上线。我们致力于为用户提供最新的影视内容，让您不再错过任何精彩。',
  },
  {
    q: '奇优影院支持哪些设备观看？',
    a: '奇优影院全面适配电脑（Windows/Mac）、平板（iPad/Android）、手机（iOS/Android）等主流设备。无需下载APP，浏览器打开即可流畅观看。',
  },
  {
    q: '可以在电视上观看奇优影院吗？',
    a: '可以，您可以通过电视浏览器直接访问奇优影院，或使用投屏功能将手机/电脑上的内容投射到电视大屏幕上观看，享受更好的观影体验。',
  },
  {
    q: '影片画质最高支持多少？',
    a: '奇优影院支持标清、高清和超清多种画质选择，最高支持1080P全高清画质。部分热门影片还提供蓝光画质选项，满足您对画质的高要求。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-900/50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm mt-3">
            关于奇优影院的使用，您可能想了解的问题
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-800/50 border border-background-700/30 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <span className="text-foreground-800 font-medium text-sm pr-4">{faq.q}</span>
                <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center">
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-foreground-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}